module.exports = __webpack_public_path__ + "img/muhammad-faiz-zulkeflee-alw-CwGFmwQ-unsplash.29719f3e.png";